'use client';
import React from 'react';

import { PreferenceContainer, PreferenceSection, PreferencesToggle } from '@benzinga/pro-ui';
import { useGlobalSetting } from '@benzinga/widget-tools';
import { WatchlistWidgetManifest } from './widget';

/** @deprecated Unused: nothing imports this. Scheduled for removal. */
export interface WatchlistSymbol {
  id: string;
  name: string;
}

export const WatchlistSettings: React.FC = () => {
  const watchlistGlobalSettings = useGlobalSetting(WatchlistWidgetManifest);

  const setEnableTickerAutoselect = React.useCallback(
    (enableTickerAutoselect: boolean) => {
      watchlistGlobalSettings.setSettings(settings => ({ ...settings, enableTickerAutoselect }));
    },
    [watchlistGlobalSettings],
  );

  const { enableTickerAutoselect } = watchlistGlobalSettings.settings;

  return (
    <PreferenceContainer subtitle="settings changed here will affect all Watchlist tools" title="Watchlist Settings">
      <PreferenceSection title="Grid Behaviour">
        <PreferencesToggle
          active={enableTickerAutoselect}
          label="Automatic symbol selection while scrolling"
          onClick={setEnableTickerAutoselect}
        />
      </PreferenceSection>
    </PreferenceContainer>
  );
};
